import Swiper from 'swiper/bundle'
import constants from '../lib/constants'

export default class {
  constructor(element) {
    if (!element) {
      return false
    }

    this.wrap = jQuery(element)
    this.slider = this.wrap.find('.s-tabs-table__items')
    this.pagination = this.wrap.find('.swiper-pagination')
    // this.swiper = null;

    this._iniSlider()
  }

  _iniSlider() {
    this.swiper = new Swiper(this.slider[0], {
      spaceBetween: 12,
      autoplay: {
        delay: 8000,
      },
      pagination: {
        clickable: true,
        el:  this.pagination[0],
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
        },
        780: {
          slidesPerView: 1,
        },
        1520: {
          slidesPerView: 'auto',
        },
      },
    })
  }
}
